module.exports = "<app-admin></app-admin>\n<app-login-page></app-login-page>"


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 0